<script setup>
import { onMounted } from "vue";

onMounted(() => {
  // Google tag (gtag.js)
  const script = document.createElement("script");
  script.async = true;
  script.src = "https://www.googletagmanager.com/gtag/js?id=G-E6F440R2R4";
  document.head.appendChild(script);

  window.dataLayer = window.dataLayer || [];
  function gtag() {
    window.dataLayer.push(arguments);
  }
  window.gtag = gtag;

  gtag("js", new Date());
  gtag("config", "G-E6F440R2R4");
});
</script>
